import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function HeartDiseaseDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Heart Disease Specific Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please confirm the patient diagnosis?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosis.referToAttachments}>
                        <p>{questions.diagnosis.subQuestions.confirmDiagnosis}</p>

                        <Question answer={formatDateMonthYear(questions.diagnosis.subQuestions.dateOfDiagnosis)}>Date of diagnosis:</Question>

                        <Question answer={questions.diagnosis.subQuestions.angiogramCompleted}>Was an Angiogram completed on the patient?</Question>

                        {questions.diagnosis.subQuestions.angiogramCompleted === 'Yes' && (
                            <>
                                <Question>If yes, please provide details of results:</Question>
                                <QuestionsContainer>
                                    <QuestionWrapper number='a'>
                                        <Question
                                            answer={formatDateMonthYear(questions.diagnosis.subQuestions.angiogramResult.dateOf)}
                                        >
                                            Date of:
                                        </Question>
                                    </QuestionWrapper>
                                    <QuestionWrapper number='b'>
                                        <Question
                                            answer={questions.diagnosis.subQuestions.angiogramResult.bloodVesselsOccluded}
                                        >
                                            Blood vessels occluded:
                                        </Question>
                                    </QuestionWrapper>
                                    <QuestionWrapper number='c'>
                                        <Question>% of blockage in each vessel:</Question>
                                        <Question
                                            answer={questions.diagnosis.subQuestions.angiogramResult.percentageBlockageInVessels.lms}
                                            suffix='%'
                                            newLine
                                        >
                                            LMS:
                                        </Question>
                                        <Question
                                            answer={questions.diagnosis.subQuestions.angiogramResult.percentageBlockageInVessels.lad}
                                            suffix='%'
                                            newLine
                                        >
                                            LAD:
                                        </Question>
                                        <Question
                                            answer={questions.diagnosis.subQuestions.angiogramResult.percentageBlockageInVessels.rca}
                                            suffix='%'
                                            newLine
                                        >
                                            RCA:
                                        </Question>
                                        <Question
                                            answer={questions.diagnosis.subQuestions.angiogramResult.percentageBlockageInVessels.cx}
                                            suffix='%'
                                            newLine
                                        >
                                            CX:
                                        </Question>
                                    </QuestionWrapper>
                                </QuestionsContainer>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>How was this medically managed?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.medicallyManaged.referToAttachments}>
                        <QuestionsContainer>
                            <QuestionWrapper number='a'>
                                <Question answer={questions.medicallyManaged.subQuestions.angioplasty}>
                                    Angioplasty:
                                </Question>

                                {questions.medicallyManaged.subQuestions.angioplasty === 'Yes' && (
                                    <>
                                        <QuestionWrapper>
                                            <Question>If yes, please confirm date and number of vessels treated:</Question>
                                        </QuestionWrapper>
                                        <QuestionWrapper>
                                            <Question answer={formatDateMonthYear(questions.medicallyManaged.subQuestions.angioplastyDetails.date)}>Date:</Question>
                                        </QuestionWrapper>
                                        <QuestionWrapper>
                                            <Question answer={questions.medicallyManaged.subQuestions.angioplastyDetails.numberOfVessels}>Number of vessels treated:</Question>
                                        </QuestionWrapper>
                                    </>
                                )}
                            </QuestionWrapper>
                            <QuestionWrapper number='b'>
                                <Question answer={questions.medicallyManaged.subQuestions.bypass}>
                                    Bypass:
                                </Question>

                                {questions.medicallyManaged.subQuestions.bypass === 'Yes' && (
                                    <>
                                        <QuestionWrapper>
                                            <Question>If yes, please confirm date and number of vessels treated:</Question>
                                        </QuestionWrapper>
                                        <QuestionWrapper>
                                            <Question answer={formatDateMonthYear(questions.medicallyManaged.subQuestions.bypassDetails.date)}>Date:</Question>
                                        </QuestionWrapper>
                                        <QuestionWrapper>
                                            <Question answer={questions.medicallyManaged.subQuestions.bypassDetails.numberOfVessels}>Number of vessels treated:</Question>
                                        </QuestionWrapper>
                                    </>
                                )}
                            </QuestionWrapper>
                            <QuestionWrapper number='c'>
                                <Question answer={questions.medicallyManaged.subQuestions.medicallyTreated}>
                                    Medically treated:
                                </Question>

                                {questions.medicallyManaged.subQuestions.medicallyTreated === 'Yes' && (
                                    <QuestionWrapper>
                                        <Question answer={questions.medicallyManaged.subQuestions.medicallyTreatedDetails}>If yes, please confirm details:</Question>
                                    </QuestionWrapper>
                                )}
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please provide Patient Follow up Investigations:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.followUps.referToAttachments}>
                        <QuestionsContainer>
                            <QuestionWrapper number='a'>
                                <Question>Resting and/or Stress ECG:</Question>
                                <OutputDetails
                                    details={questions.followUps.subQuestions.ecg}
                                />
                            </QuestionWrapper>

                            <QuestionWrapper number='b'>
                                <Question>Echo (including LV EF):</Question>
                                <OutputDetails
                                    details={questions.followUps.subQuestions.echo}
                                />
                            </QuestionWrapper>

                            <QuestionWrapper number='c'>
                                <Question>Most recent Cardiac Follow up:</Question>
                                <OutputDetails
                                    details={questions.followUps.subQuestions.cardiac}
                                />
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Please comment on your patients current cardiac health?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.commentOnCurrentCardiacHealth.referToAttachments}>
                        <p>{questions.commentOnCurrentCardiacHealth.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}
